// Routes where the authentication is not checked
const NO_AUTH_ROUTES = [
  'password-recovery',
  'username-recovery',
  'password-update',
  'login',
  'signup',
  '404',
  'password-generator',
  'unsubscribe',
  'test',
]
export default NO_AUTH_ROUTES



// WEBPACK FOOTER //
// ./src/router/no_auth_routes.js